var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownWhiteChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.578062 0.744078C0.903499 0.418641 1.43114 0.418641 1.75657 0.744078L7.00065 5.98816L12.2447 0.744078C12.5702 0.418641 13.0978 0.418641 13.4232 0.744078C13.7487 1.06951 13.7487 1.59715 13.4232 1.92259L7.58991 7.75592C7.26447 8.08136 6.73683 8.08136 6.41139 7.75592L0.578062 1.92259C0.252625 1.59715 0.252625 1.06951 0.578062 0.744078Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownWhiteChevron);
export default __webpack_public_path__ + "static/media/down-white-chevron.944caeb677db26fa5a8250c1a7094d39.svg";
export { ForwardRef as ReactComponent };